import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
/**
 * Reusable content container for page bodies.
 * Keeps spacing consistent across dashboard pages.
 */
export default function PageContainer({ children }) {
    return (_jsx(Box, { component: "main", sx: {
            p: 3,
            width: "100%",
            minHeight: "100%",
        }, children: children }));
}
